<template>
  <div id="ClientsList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>lientes</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12" :style="{ height: $store.state.body_h + 'px'}" style="overflow-y: auto;">
      <div class="col-12 pl5 pr5 mt5" v-for="(client,client_i) in data_list" v-bind:key="client_i" @click="go_client(client.appid)">
        <div class="col-12">
          <div class="col-12 bg-color-white r5 p5">
              <div class="col-2 f40 color-primary br1 t-c"><i class="iconfont icon-jinrudianpu"></i></div>
              <div class="col-9 pl10">
                <div class="col-12 f14">{{client.license_type}}{{ client.license }} <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5" v-if="client.is_specials == 1">C.E</span> </div>
                <div class="col-12 fw f16"><span class="bg-color-muted color-white f12 pt1 pb1 pl5 pr5 r50 mr3">{{ client.store}}</span>{{ client.enterprise_name }}</div>
                <div class="col-12 color-muted f12">{{ client.update_time}}</div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="h5"></div>
    <div ref="app_foot" class="col-12 fixed-b t-c color-white f14 bg-color1 lh50 t-c-v">
      <div class="fl"><input type="text" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w28" placeholder="RIF" v-model="keyword"></div>
      <div class="b-s-2 r5 w4 h4 fl bg-color-white t-c-v f26 ml5" :class="[keyword != '' && keyword.length > 1?'color-primary fw':'color2']" @click="get_list_data()"><i class="iconfont icon-search"></i></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ClientsList',
  data () {
    return {
      aid: '',
      keyword: '',
      new_store: false,
      data_list: [],
    }
  },
  created: function () {
    this.keyword = this.$store.state.client_keyword;
    this.aid = this.$route.query.aid;
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var keyword = this.keyword;
      if(keyword < 2){
        //return;
      }
      var post_data = {};
      post_data.keyword = keyword;
      let url = this.api_url + 'Agent/clients';
      if(this.aid){
        url = this.api_url + 'Agent/client_list';
        post_data.aid = this.aid;
      }
      this.new_store = false;
      this.post(url, post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data;
          this.$store.commit('setClientKeyword', keyword);
          this.$store.commit('setBodyH', this);
        }else{
          this.data_list = []
          if(res.status == 2){
            //this.$router.push({name:'Activation',params:{rif: res.data, act_type: 0}});
          }
        }
      })
    },
    go_client(appid){
      this.$router.push({name:'A_Client',query:{appid: appid}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/ClientsList.vue